export enum StockInputTypeEnum {
    TrafficSign = 'TRAFFIC_SIGN',
    Support = 'SUPPORT',
    Device = 'DEVICE',
  }
  
  